import { GlobalSettingsConfig } from './global-settings/app-config'
import { AppConfigDescriptor } from '../common/types/app-config'
import { BusinessUnitsConfig } from './business-units/app-config'
import { GetCRMConfig } from './crm/app-config'

export const AppList: Array<AppConfigDescriptor | Promise<AppConfigDescriptor>> = [GlobalSettingsConfig, BusinessUnitsConfig, GetCRMConfig()]
